import { useGetCustomerConfigurations } from 'api';

import { useOrganisationId } from './context';
import { useFeatures } from './useFeatures';

/**
 *
 * This checks which features are enabled.
 */
export const useFeatureAccessControl = () => {
  const organisationId = useOrganisationId<number>();
  const {
    data: { data: orgSettings } = {},
    isLoading: isCustomerConfigurationLoading
  } = useGetCustomerConfigurations(organisationId);

  const { getFeatureFlag, isLoading: isFeatureFlagLoading } = useFeatures();

  const isManualPayoutEnabled =
    orgSettings?.manual_payouts_enabled !== undefined &&
    Number(orgSettings.manual_payouts_enabled) > 0;

  const isBatchesPageEnabled =
    !!getFeatureFlag('CBP-1761-customer-app-batches') &&
    orgSettings?.batches_enabled !== undefined &&
    Number(orgSettings.batches_enabled) > 0;

  const isReceiverManagementEnabled = !!getFeatureFlag(
    'CBP-8000-receiver-management'
  );

  const isBatchApprovalRequired =
    orgSettings?.batch_number_of_approvers !== undefined &&
    Number(orgSettings.batch_number_of_approvers) > 0;

  const isManualPayoutApprovalFlowEnabled = !!getFeatureFlag(
    'CBP-2001-approval-workflow-manual-payouts'
  );

  const isPayoutDraftApprovalRequired =
    orgSettings?.manual_payout_number_of_approvers !== undefined &&
    Number(orgSettings.manual_payout_number_of_approvers) > 0;

  const isPayoutDraftApprovalFlowEnabled =
    isManualPayoutApprovalFlowEnabled &&
    isManualPayoutEnabled &&
    isPayoutDraftApprovalRequired;

  const isWithdrawalRequestsEnabled = !!getFeatureFlag(
    'CBP-2870-withdrawal-accounts-enabled'
  );

  const isSandboxTestCasesEnabled = !!getFeatureFlag(
    'CBP-10746-e2e-test-cases-field-enabled'
  );

  const isSandboxFundingEnabled = !!getFeatureFlag(
    'PEGO-12738-sandbox-customer-app-api-docs'
  );

  const isCreateReceiverEnabled = !!getFeatureFlag(
    'PEGO-12664-create-receiver'
  );

  const isSelfServiceDeveloperSettingsEnabled = !!getFeatureFlag(
    'PEGO-13634-self-service-developer-settings'
  );

  const isMcpTokensEnabled = !!getFeatureFlag('PEGO-14432-mcp-tokens');

  const isCustomerABTestingEnabled =
    orgSettings?.customer_ab_testing &&
    Number(orgSettings.customer_ab_testing) > 0;

  return {
    isSandboxFundingEnabled,
    isManualPayoutEnabled,
    isBatchesPageEnabled,
    isReceiverManagementEnabled,
    isBatchApprovalRequired,
    isManualPayoutApprovalFlowEnabled,
    isPayoutDraftApprovalFlowEnabled,
    isWithdrawalRequestsEnabled,
    isSandboxTestCasesEnabled,
    isCustomerABTestingEnabled,
    isLoading: isCustomerConfigurationLoading || isFeatureFlagLoading,
    isCreateReceiverEnabled,
    isSelfServiceDeveloperSettingsEnabled,
    isMcpTokensEnabled
  };
};
